import { useState } from 'react';
import { useEffectOnce } from 'react-use';

export const useScroll = () => {
  const [scrollY, setScrollY] = useState(0);
  const [isIOS, setIsIOS] = useState(false);

  useEffectOnce(() => {
    // @ts-ignore
    setIsIOS(/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
  });

  const enableScroll = () => {
    document.body.style.overflow = 'visible';

    if (isIOS) {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.bottom = '';
      window.scrollTo(0, scrollY);
      // @ts-ignore
      document.body.style.webkitOverflowScrolling = 'auto';
    }
  };
  const disableScroll = () => {
    document.body.style.overflow = 'hidden';

    if (isIOS) {
      const y = window.pageYOffset;
      setScrollY(y);
      document.body.style.top = `-${y}px`;
      document.body.style.position = 'fixed';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.bottom = '0';
      // @ts-ignore
      document.body.style.webkitOverflowScrolling = 'touch';
    }
  };

  return { disableScroll, enableScroll };
};
